import { useEffect, useState } from 'react'

export const useCopyToClipboard = () => {
    const [isCopied, setIsCopied] = useState(false)
    let timeoutId: NodeJS.Timeout

    useEffect(() => () => clearTimeout(timeoutId), [])

    const handleCopyToClipboard = async (textToCopy: string) => {
        try {
            // eslint-disable-next-line
            await navigator.clipboard.writeText(textToCopy)
            setIsCopied(true)
            clearTimeout(timeoutId)

            timeoutId = setTimeout(() => {
                setIsCopied(false)
            }, 5000)
        } catch (err) {
            console.error('Failed to copy: ', err)
        }
    }

    return { handleCopyToClipboard, isCopied }
}
